/**
 * Gramática's launcher — the shared grammar home, named.
 *
 * Everything structural lives in `src/apps/shared/grammar/AppHome.tsx` so a
 * change to how the course is presented reaches Grammatik too.
 */
import { GrammarAppHome } from '../shared/grammar/AppHome';
import type { AppHomeProps } from '../types';

import { gramaticaCourse } from './course';

export function AppHome({ appId }: AppHomeProps) {
  return (
    <GrammarAppHome
      appId={appId}
      course={gramaticaCourse}
      displayName="Gramática"
      tagline="Uma regra por dia."
    />
  );
}
